<footer class="px-[25px] bg-white dark:bg-[#1b1d2a]">
    <div class="flex justify-between flex-wrap py-[22px] gap-x-[30px] gap-y-[15px] items-center max-md:flex-col">
        <div class="flex items-center gap-[4px] text-[14px] font-medium max-md:text-center text-theme-gray dark:text-white/60">
            © {{currentYear}} <a class="text-primary" [href]="lacpointSiteUrl" target="_blank">Lacpoint</a>
            <span class="text-[10px] text-gray-300 ml-2 opacity-50">v{{ appVersion }}</span>
        </div>
    </div>
</footer>
